export default __webpack_public_path__ + "static/media/ETH.1c23fa09.jpg";